package com.anjuros.website.templates.template6.modules

import com.anjuros.website.templates.template6.util.ResKey


enum class Template6FAQ(
    val question:ResKey,
    val answer:ResKey) {

    FAQItem1(
        ResKey.TEMPLATE6_FAQ1_Q,
        ResKey.TEMPLATE6_FAQ1_A
    ),

    FAQItem2(
    ResKey.TEMPLATE6_FAQ2_Q,
    ResKey.TEMPLATE6_FAQ2_A
    ),

    FAQItem3(
    ResKey.TEMPLATE6_FAQ3_Q,
    ResKey.TEMPLATE6_FAQ3_A
    ),

    FAQItem4(
    ResKey.TEMPLATE6_FAQ4_Q,
    ResKey.TEMPLATE6_FAQ4_A
    ),

    FAQItem5(
    ResKey.TEMPLATE6_FAQ5_Q,
    ResKey.TEMPLATE6_FAQ5_A
    ),

    FAQItem6(
    ResKey.TEMPLATE6_FAQ6_Q,
    ResKey.TEMPLATE6_FAQ6_A
    )

}